import { render, staticRenderFns } from "./SpecificJobSearch.vue?vue&type=template&id=70d72450&scoped=true&"
import script from "./SpecificJobSearch.vue?vue&type=script&lang=ts&"
export * from "./SpecificJobSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d72450",
  null
  
)

export default component.exports